"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageType = void 0;
var PageType;
(function (PageType) {
    PageType["STARTSEITE"] = "startseite";
    PageType["TARIF_UEBERSICHTSSEITEN"] = "tarif-uebersichtsseiten";
    PageType["TARIF_DETAILSEITEN"] = "tarif-detailseiten";
    PageType["ENDGERAETE_LISTEN"] = "endgeraete-listen";
    PageType["ENDGERAETE_DETAILSEITEN"] = "endgeraete-detailseiten";
    PageType["ENDGERAETE_ANGEBOTESEITEN"] = "endgeraete-angeboteseiten";
    PageType["OPTIONEN"] = "optionen";
    PageType["HILFE_UND_SERVICE"] = "hilfe-und-service";
    PageType["MEIN_CONGSTAR"] = "mein-congstar";
    PageType["DAS_IST_CONGSTAR"] = "das-ist-congstar";
    PageType["CHECKOUT"] = "checkout";
    PageType["AKTIVIERUNG_PREPAID"] = "aktivierung-prepaid";
    PageType["ANSCHLUSSKONFIGURATION"] = "anschlusskonfiguration";
    PageType["CONTENT"] = "content";
    PageType["SONSTIGE"] = "sonstige";
    PageType["FORUM"] = "forum";
    PageType["SUCHERGEBNIS"] = "suchergebnis";
    PageType["FEHLERSEITE"] = "fehlerseite";
    PageType["FIXED_ONBOARDING"] = "fixed-onboarding";
})(PageType || (exports.PageType = PageType = {}));
